export const SITE_URL = "https://avps.it";
export const SITE_NAME = "AVPS Vimercate";

export interface RouteMeta {
  title: string;
  description: string;
  type?: "website" | "article";
}

export const routeMeta: Record<string, RouteMeta> = {
  "/": {
    title: "AVPS Vimercate | Pubblica Assistenza e Pronto Soccorso",
    description:
      "Associazione Volontari Pronto Soccorso Vimercate: emergenza 112, trasporto sanitario, teleassistenza, corsi e supporto alla comunità dal 1973.",
  },
  "/chi-siamo": {
    title: "Chi siamo | AVPS Vimercate",
    description:
      "Storia, organizzazione, mezzi e rete ANPAS dell'Associazione Volontari Pronto Soccorso di Vimercate.",
  },
  "/chi-siamo/storia": {
    title: "La nostra storia dal 1973 | AVPS Vimercate",
    description:
      "Oltre cinquant'anni di soccorso e volontariato a Vimercate: le tappe principali della storia di AVPS.",
  },
  "/chi-siamo/organizzazione": {
    title: "Organizzazione e organi associativi | AVPS Vimercate",
    description:
      "Come è organizzata AVPS Vimercate: consiglio direttivo, soccorritori, dipendenti e organi associativi.",
  },
  "/chi-siamo/noi-e-anpas": {
    title: "AVPS e ANPAS | AVPS Vimercate",
    description:
      "Il legame tra AVPS Vimercate e ANPAS: rete nazionale di pubbliche assistenze, protezione civile e formazione.",
  },
  "/chi-siamo/trasparenza": {
    title: "Trasparenza e contributi pubblici | AVPS Vimercate",
    description:
      "Documenti di trasparenza di AVPS Vimercate e pubblicazione dei contributi pubblici ricevuti ai sensi della Legge 124/2017.",
  },
  "/chi-siamo/i-nostri-mezzi": {
    title: "I nostri mezzi e ambulanze | AVPS Vimercate",
    description:
      "Ambulanze, automediche e mezzi per il trasporto sanitario in dotazione ad AVPS Vimercate.",
  },
  "/servizi": {
    title: "Servizi sanitari e assistenza | AVPS Vimercate",
    description:
      "Emergenza 112, trasporto sanitario programmato, teleassistenza, assistenza eventi, corsi e servizio civile a Vimercate.",
  },
  "/servizi/emergenza-sanitaria-112": {
    title: "Emergenza sanitaria 112 | AVPS Vimercate",
    description:
      "Il servizio di emergenza urgenza 112 di AVPS Vimercate: equipaggi di soccorritori attivi 24 ore su 24 sul territorio.",
  },
  "/servizi/trasporto-sanitario-programmato": {
    title: "Trasporto sanitario programmato | AVPS Vimercate",
    description:
      "Trasporti per visite, dimissioni, dialisi e terapie con ambulanza o mezzi attrezzati a Vimercate e nel Vimercatese.",
  },
  "/servizi/teleassistenza": {
    title: "Teleassistenza e telesoccorso | AVPS Vimercate",
    description:
      "Servizio di teleassistenza e telesoccorso di AVPS Vimercate per anziani e persone fragili a domicilio.",
  },
  "/servizi/assistenza-manifestazioni-eventi": {
    title: "Assistenza sanitaria a eventi e manifestazioni | AVPS Vimercate",
    description:
      "Copertura sanitaria per gare sportive, manifestazioni e eventi pubblici con soccorritori e ambulanze AVPS.",
  },
  "/servizi/corsi-formazione-sanitaria": {
    title: "Corsi di formazione sanitaria e primo soccorso | AVPS Vimercate",
    description:
      "Corsi di primo soccorso, BLSD e il Corso Regionale di Soccorritore organizzati da AVPS Vimercate.",
  },
  "/servizi/assistenza-guardia-medica": {
    title: "Continuità assistenziale (guardia medica) | AVPS Vimercate",
    description:
      "Il supporto di AVPS Vimercate al servizio di continuità assistenziale, ex guardia medica, sul territorio.",
  },
  "/servizi/servizio-civile": {
    title: "Servizio civile universale | AVPS Vimercate",
    description:
      "Come partecipare al servizio civile universale con AVPS Vimercate: requisiti, attività e come candidarsi.",
  },
  "/diventa-volontario": {
    title: "Diventa soccorritore volontario | AVPS Vimercate",
    description:
      "Entra in AVPS Vimercate: formazione gratuita, corso soccorritore e attività di volontariato nel soccorso sanitario.",
  },
  "/iniziative": {
    title: "Iniziative e progetti solidali | AVPS Vimercate",
    description:
      "Le iniziative solidali di AVPS Vimercate sul territorio e i progetti realizzati con altre associazioni.",
  },
  "/iniziative/una-stella-in-ambulanza": {
    title: "Una stella in ambulanza | AVPS Vimercate",
    description:
      "L'iniziativa solidale «Una stella in ambulanza» di AVPS Vimercate: come partecipare e sostenerla.",
  },
  "/iniziative/progetti-con-altre-associazioni": {
    title: "Progetti con altre associazioni | AVPS Vimercate",
    description:
      "I progetti di solidarietà realizzati da AVPS Vimercate insieme ad altre associazioni in Italia e all'estero.",
  },
  "/news": {
    title: "Notizie e aggiornamenti | AVPS Vimercate",
    description:
      "Ultime notizie, comunicazioni e aggiornamenti dalle attività di AVPS Vimercate.",
    type: "article",
  },
  "/eventi": {
    title: "Eventi e appuntamenti | AVPS Vimercate",
    description:
      "Prossimi appuntamenti e attività svolte da AVPS Vimercate: eventi pubblici, coperture sanitarie e iniziative.",
    type: "article",
  },
  "/contatti": {
    title: "Contatti | AVPS Vimercate",
    description:
      "Telefono, email e recapiti di AVPS Vimercate per informazioni, trasporti sanitari e collaborazioni.",
  },
  "/contatti/le-sedi": {
    title: "Le nostre sedi | AVPS Vimercate",
    description:
      "Indirizzi e mappe delle sedi AVPS a Vimercate e sul territorio, con orari di apertura.",
  },
  "/contatti/lavora-con-noi": {
    title: "Lavora con noi | AVPS Vimercate",
    description:
      "Posizioni aperte e come candidarsi per lavorare come soccorritore o autista con AVPS Vimercate.",
  },
  "/sostienici": {
    title: "Sostieni AVPS | AVPS Vimercate",
    description:
      "Dona, destina il 5x1000 o diventa Amico di AVPS: tutti i modi per sostenere il soccorso a Vimercate.",
  },
  "/sostienici/5x1000-donazioni": {
    title: "5x1000 e donazioni | AVPS Vimercate",
    description:
      "Destina il 5x1000 ad AVPS Vimercate (C.F. 87011130157) o effettua una donazione tramite bonifico.",
  },
  "/sostienici/diventa-amico-avps": {
    title: "Diventa Amico di AVPS | AVPS Vimercate",
    description:
      "Sostieni le attività di soccorso diventando Amico di AVPS Vimercate con un contributo annuale.",
  },
  "/sostienici/lascito-testamentario": {
    title: "Lascito testamentario | AVPS Vimercate",
    description:
      "Come destinare un lascito testamentario ad AVPS Vimercate per sostenere il soccorso sul territorio.",
  },
  "/sos-cittadino": {
    title: "SOS Cittadino | AVPS Vimercate",
    description:
      "Il servizio SOS Cittadino di AVPS Vimercate: invia una richiesta di aiuto o supporto sanitario non urgente.",
  },
  "/privacy": {
    title: "Informativa privacy | AVPS Vimercate",
    description:
      "Informativa sul trattamento dei dati personali ai sensi del GDPR di AVPS Vimercate.",
  },
  "/cookie-policy": {
    title: "Cookie policy | AVPS Vimercate",
    description:
      "Informazioni sui cookie tecnici utilizzati dal sito di AVPS Vimercate.",
  },
};

export const defaultMeta: RouteMeta = routeMeta["/"];

export function getRouteMeta(pathname: string): RouteMeta {
  const clean =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;
  if (routeMeta[clean]) return routeMeta[clean];
  // Fall back to the closest parent section
  const parts = clean.split("/").filter(Boolean);
  while (parts.length > 0) {
    parts.pop();
    const parent = "/" + parts.join("/");
    if (routeMeta[parent]) return routeMeta[parent];
  }
  return defaultMeta;
}
